import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import t from "../common/base-provider.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { newBannerFromJson as n, newBannerFromSerializedValue as o } from "./banner-factory.js";
import h from "../util/request-header-utils.js";
import a from "../util/net.js";
import { randomInclusive as l } from "../util/math.js";
import u from "../managers/subscription-manager.js";
import r from "../managers/braze-instance.js";
import c from "../common/event-logger.js";
import { EventTypes as m } from "../../shared-lib/event-types.js";
var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);
  var _super = _createSuper(e);
  function e(t, s, i, _e) {
    var _this;
    _classCallCheck(this, e);
    _this = _super.call(this), _this.h = t, _this.B = s, _this.j = i, _this.C = _e, _this.banners = {}, _this.h = t, _this.B = s, _this.j = i, _this.C = _e, _this.S = 10, _this.T = null, _this.I = null, _this.R = new u(), r.q(_this.R), _this.D = null, _this.F = null;
    return _this;
  }
  _createClass(e, [{
    key: "N",
    value: function N(t) {
      if (this.k() && null != t && t.banners) {
        this.banners = {};
        var _s = t.banners;
        for (var _t2 in _s) {
          var i = _s[_t2];
          var _e2 = null;
          null != i && null != i.banner && (_e2 = n(i.banner)), _e2 && (this.banners[_t2] = _e2);
        }
        this.U(), this.R.L(this.banners);
      }
    }
  }, {
    key: "M",
    value: function M(t, s, i) {
      var _this2 = this;
      var _e3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var n;
      var r = function r() {
        "function" == typeof i && i();
      };
      if (!this.k()) return void (null === (n = this.h) || void 0 === n || n.P(function () {
        _this2.M(t, s, i);
      }));
      var o = this.B;
      if (!o) return void r();
      _e3 && this.X();
      var u = o.$({}, !0),
        c = [];
      var _iterator = _createForOfIteratorHelper(t),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s2 = _step.value;
          c.push({
            id: _s2
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      u.placements = c;
      var m = o.A(u, h.H.G);
      var d = !1;
      o.J(u, function () {
        var _e4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var n = _this2.B;
        if (!n) return void r();
        var o = new Date().valueOf();
        h.K(_this2.j, h.H.G, o), -1 !== _e4 && m.push(["X-Braze-Req-Tokens-Remaining", _e4.toString()]), a.O({
          url: "".concat(n.V(), "/banners/sync"),
          headers: m,
          data: u,
          W: function W(t) {
            if (!n.Y(u, t, m)) return d = !0, void r();
            n.Z(), _this2.N(t), d = !1, "function" == typeof s && s();
          },
          error: function error(t) {
            n._(t, "retrieving banners"), d = !0, r();
          },
          tt: function tt(_e5, r) {
            var o;
            if (_this2.F = t, d) {
              var _t3 = _this2.T;
              (null == _t3 || _t3 < 1e3 * _this2.S) && (_t3 = 1e3 * _this2.S), o = Math.min(3e5, l(1e3 * _this2.S, 3 * _t3));
            }
            n.st(r, function () {
              _this2.M(t, s, i, !1);
            }, h.H.G, function (t) {
              return _this2.it(t);
            }, function () {
              return _this2.X();
            }, o);
          }
        });
      }, h.H.G, i);
    }
  }, {
    key: "et",
    value: function et() {
      return this.F;
    }
  }, {
    key: "nt",
    value: function nt(t, s) {
      var i = {
        id: t.id
      };
      s && (i.bid = s);
      return c.rt(m.ot, i).W;
    }
  }, {
    key: "X",
    value: function X() {
      null != this.I && (clearTimeout(this.I), this.I = null);
    }
  }, {
    key: "it",
    value: function it(t) {
      this.X(), this.I = t;
    }
  }, {
    key: "ht",
    value: function ht() {
      var t = {};
      this.j && (t = this.j.lt(s.ct.ut));
      var i = {};
      for (var _s3 in t) {
        var _e6 = null;
        null != t[_s3] && (_e6 = o(t[_s3])), _e6 && (i[_e6.placementId] = _e6);
      }
      return i;
    }
  }, {
    key: "U",
    value: function U() {
      var t;
      if (!this.j) return;
      var i = {};
      for (var _s4 in this.banners) {
        var _e7 = (null === (t = this.banners[_s4]) || void 0 === t ? void 0 : t.dt()) || null;
        i[_s4] = _e7;
      }
      this.j.ft(s.ct.ut, i), this.vt();
    }
  }, {
    key: "vt",
    value: function vt() {
      var t, i;
      null === (t = this.j) || void 0 === t || t.ft(s.ct.gt, null === (i = this.C) || void 0 === i ? void 0 : i.bt());
    }
  }, {
    key: "Bt",
    value: function Bt() {
      var t;
      return (null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.gt)) || null;
    }
  }, {
    key: "jt",
    value: function jt() {
      return this.D;
    }
  }, {
    key: "yt",
    value: function yt(t) {
      this.D = t;
    }
  }, {
    key: "Ct",
    value: function Ct() {
      var t;
      var s = null === (t = this.C) || void 0 === t ? void 0 : t.bt(),
        i = this.Bt();
      return null == i || s === i;
    }
  }, {
    key: "St",
    value: function St(t) {
      return this.R.wt(t);
    }
  }, {
    key: "Tt",
    value: function Tt() {
      var t;
      return (null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.It)) || {};
    }
  }, {
    key: "Rt",
    value: function Rt(t) {
      this.j && this.j.ft(s.ct.It, t);
    }
  }, {
    key: "changeUser",
    value: function changeUser() {
      this.qt(), this.X();
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.X();
    }
  }, {
    key: "k",
    value: function k() {
      return !!this.h && (!!this.h.Dt() || (0 !== this.h.Ft() && this.qt(), !1));
    }
  }, {
    key: "qt",
    value: function qt() {
      this.banners = {}, this.j && (this.j.Nt(s.ct.ut), this.j.Nt(s.ct.It)), this.R.L({});
    }
  }]);
  return e;
}(t);
export { e as default };